import React from 'react'

export default function About() {
  return (
    <div id="about">
      <h3>Sobre</h3>
      <h4>
        Trabalho referente ao Projeto Integrador para Engenharia de Computação
        II-A
      </h4>
      <p>
        Projeto este que visa em ajudar os alunos de Engenharia com uma pequena
        abordagem sobre derivadas, onde explicamos um pouco como aplicara regra
        do "tombo".
      </p>
      <p>
        Desenvolvido pelos alunos do curso de Engenharia de Computação da
        Univesp - polo de Ipaussu/SP.
      </p>
      <p>Alunos que participaram do desenvolvimento do Projeto.</p>
      <p>Adeline Vaz Fernandes</p>
      <p>Marcius Junior O. de Araujo</p>
      <p>Matheus Camargo de Oliveira</p>
      <p>Tiago Batista</p>
      <p>William Aparecido Leda Ribeiro</p>
    </div>
  )
}
